"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _app = require("@rainbow-modules/app");

var _firebaseHooks = require("@rainbow-modules/firebase-hooks");

var _icons = require("./icons");

var _styled = require("./styled");

var _labels = require("./labels");

var _messages = _interopRequireDefault(require("./messages"));

var EmailPasswordSignUpForm = function EmailPasswordSignUpForm(props) {
  var intl = (0, _reactIntl.useIntl)();
  var className = props.className,
      style = props.style;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      name = _useState2[0],
      setName = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      password = _useState6[0],
      setPassword = _useState6[1];

  var app = (0, _firebaseHooks.useFirebaseApp)();
  var namePlaceholder = intl.formatMessage(_messages["default"].namePlaceholder);
  var emailPlaceholder = intl.formatMessage(_messages["default"].emailPlaceholder);
  var passwordPlaceholder = intl.formatMessage(_messages["default"].passwordPlaceholder);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
      var user;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              _context.prev = 1;
              (0, _app.showAppSpinner)();
              _context.next = 5;
              return app.auth().createUserWithEmailAndPassword(email, password);

            case 5:
              user = app.auth().currentUser;
              _context.next = 8;
              return user.updateProfile({
                displayName: name
              });

            case 8:
              (0, _app.hideAppSpinner)();
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              (0, _app.hideAppSpinner)();
              (0, _app.showAppMessage)({
                message: "".concat(_context.t0),
                variant: 'error'
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement("form", {
    className: className,
    style: style,
    onSubmit: handleSubmit,
    noValidate: true
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledInput, {
    label: _labels.nameLabel,
    icon: _icons.nameIcon,
    placeholder: namePlaceholder,
    name: "name",
    onChange: function onChange(event) {
      return setName(event.target.value);
    },
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_styled.StyledInput, {
    label: _labels.emailLabel,
    icon: _icons.emailIcon,
    placeholder: emailPlaceholder,
    type: "email",
    name: "email",
    onChange: function onChange(event) {
      return setEmail(event.target.value);
    },
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_styled.StyledInput, {
    label: _labels.passwordLabel,
    icon: _icons.passwordIcon,
    placeholder: passwordPlaceholder,
    type: "password",
    name: "password",
    onChange: function onChange(event) {
      return setPassword(event.target.value);
    },
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_styled.StyledButton, {
    label: _labels.buttonLabel,
    variant: "brand",
    type: "submit"
  }));
};

EmailPasswordSignUpForm.propTypes = {
  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
EmailPasswordSignUpForm.defaultProps = {
  className: undefined,
  style: undefined
};
var _default = EmailPasswordSignUpForm;
exports["default"] = _default;